<template>
  <vs-row style="height: 100%; position:relative;">
    <vs-col vs-w="12">
      <div class="vx-card form-card" ref="card">
        <div class="vx-card__header">
          <vs-col vs-type="flex" vs-justify="space-between" vs-align="center" vs-w="12" vs-lg="12" vs-sm="12" vs-xs="12">
            <h3>{{ [this.id ? 'MODIFICA' : 'NUOVO','DOCUMENTO'].join(' ')}}</h3>
            <feather-icon icon="XIcon" @click="closeSidebar" class="cursor-pointer"></feather-icon>
          </vs-col>
        </div>
        <vs-divider />
        <div class="vx-card__body">
          <form v-on:submit.prevent="" data-vv-scope="documento">
            <vs-row>
              <vs-col vs-type="flex" vs-justify="flex-start" class="w-full px-2">
                <label class="text-sm mr-6">Scegli il tipo:</label>
                <vs-radio v-model="radio_ca" vs-value="azienda" class=" mr-4">Azienda</vs-radio>
                <vs-radio v-model="radio_ca" vs-value="contatto" >Contatto</vs-radio>
              </vs-col>
              <vs-col v-if="radio_ca == 'azienda'" :key="selectorKey" class="w-full px-2">
                <label class="text-sm">Azienda</label>
                <v-select name="azienda" class="w-full" placeholder="Scrivi la ragione sociale dell'azienda.." :options="aziende" @search="fetchAziende" v-model="azienda" v-validate="radio_ca == 'azienda' ? 'required' : ''" :filterable="false"><span slot="no-options">Nessun risultato</span></v-select>
                <span class="text-danger text-sm" v-show="errors.has('documento.azienda')">{{ errors.first('documento.azienda') }}</span>
              </vs-col>
              <vs-col v-if="radio_ca == 'contatto'" :key="selectorKey" class="w-full px-2">
                <label class="text-sm">Contatto</label>
                <v-select name="contatto" class="w-full" placeholder="Scrivi il nome del contatto.." :options="contatti" @search="fetchContatti" v-model="contatto" v-validate="radio_ca == 'contatto' ? 'required' : ''" :filterable="false"><span slot="no-options">Nessun risultato</span></v-select>
                <span class="text-danger text-sm" v-show="errors.has('documento.contatto')">{{ errors.first('documento.contatto') }}</span>
              </vs-col>
              <vs-col class="w-full px-2 mt-3">
                <vs-input v-model="descrizione" label-placeholder="Descrizione contenuto documento" class="is-label-placeholder w-full" name="descrizione" v-validate="'required'" />
                <span class="text-danger text-sm" v-show="errors.has('documento.descrizione')">{{ errors.first('documento.descrizione') }}</span>
              </vs-col>
            </vs-row>
            <vs-row>
              <vs-col class="w-full px-2 mt-3">
                <label class="text-sm">Categoria documento</label>
                <v-select name="categoria" class="w-full" placeholder="Categoria.." :options="categoria_list" v-model="categoria" v-validate="'required'"></v-select>
                <span class="text-danger text-sm" v-show="errors.has('documento.categoria')">{{ errors.first('documento.categoria') }}</span>
              </vs-col>
              <vs-col class="w-full px-2 mt-3">
                <label class="vs-input--label">Data Scadenza</label>
                <datepicker typeable placeholder="Inserisci la data di scadenza..." :language="languages['it']" :format="datepicker_format" name="data_scadenza" v-model="data_scadenza"></datepicker>
                <span class="text-danger text-sm" v-show="errors.has('documento.data_scadenza')">{{ errors.first('documento.data_scadenza') }}</span>
              </vs-col>
            </vs-row>
            <vs-row>
              <vs-col class="w-full px-2 mt-3">
                <label class="text-sm">Carica Documento</label>
                <drag-drop-file v-if="!id" v-model="file" v-validate="'required'" name="file" :disabled="this.id ? true : false"></drag-drop-file>
                <span class="text-danger" id="fileError"></span>
              </vs-col>
            </vs-row>
          </form>
        </div>
        <div class="vx-card__footer">
          <vs-row vs-type="flex" vs-justify="space-around">
            <vs-button @click="submitFile($event)" type="line" color="success" icon-pack="feather" icon="icon-save">Salva</vs-button>
          </vs-row>
        </div>
      </div>
    </vs-col>
  </vs-row>

</template>

<script>
// For custom error message
import { Validator } from 'vee-validate';

// axios
import axios from 'axios'

// vue-select
import vSelect from 'vue-select'

// datepicker + languages
import Datepicker from '@sum.cumo/vue-datepicker';
import '@sum.cumo/vue-datepicker/dist/vuejs-datepicker.css'
import * as lang from 'vuejs-datepicker/src/locale';

import DragDropFile from '../commons/DragDropFile.vue'


const dict = {
  custom: {
    file: {
      required: 'Selezionare un file'
    },
    azienda: {
      required: 'Selezionare un\'Azienda'
    },
    contatto: {
      required: 'Selezionare un Contatto'
    },
    categoria: {
      required: 'Categoria è un campo obbligatorio'
    },
    descrizione: {
      required: 'Descrizione è un campo obbligatorio'
    },
    data_scadenza: {
      required: 'Data di scadenza è un campo obbligatorio'
    },
  }
};

// register custom messages
Validator.localize('it', dict);

export default {
  data() {
    return {
      datepicker_format: "d.MM.yyyy",
      languages: lang,

      id: null,
      file: {},
      categoria_list: ["Carta d'identità","Passaporto","Tessera sanitaria","Visura camerale","Contratto","Altro"],
      categoria: "",

      descrizione: "",
      data_scadenza: "",

      radio_ca: 'azienda',
      selectorKey: null,
      aziende: [],
      azienda: null,
      contatti: [],
      contatto: null,

      canEdit: false,
    }
  },
  props: {
    selected: Object,
  },
  methods: {
    fetchAziende(q, loading) {
      if (q.trim().length < 3) {
        this.aziende = []
        this.contatti = []
        return
      }
      loading(true)
      axios.post(process.env.VUE_APP_BACKEND_API+'/azienda/trova_live', { keyword: q }, {
        headers: { "Access-Control-Allow-Origin": "*", 'Content-Type': 'application/json',},
        withCredentials: true,
      }).then(e => {
        this.contatto = null
        this.contatti = []
        this.aziende = e.data.map(e => {
          e['label'] = `${e['ragione_sociale']} - ${e['codice_fiscale']}`
          return e
        })
        loading(false)
      })
    },
    fetchContatti(q, loading) {
      if (q.trim().length < 3) {
        this.aziende = []
        this.contatti = []
        return
      }
      loading(true)
      axios.post(process.env.VUE_APP_BACKEND_API+'/contatto/trova_live', { keyword: q }, {
        headers: { "Access-Control-Allow-Origin": "*", 'Content-Type': 'application/json',},
        withCredentials: true,
      }).then(e => {
        this.aziende = []
        this.azienda = null
        this.contatti = e.data.map(e => {
          e['label'] = `${e['nome']} ${e['cognome']}`
          return e
        })
        loading(false)
      })
    },
    submitFile(){
      this.validateDocumento().then(() => {
        let url = this.azienda && this.azienda.id ? '/azienda/documento/upload' : '/contatto/documento/upload'
        let formData = new FormData();
        if (!this.id) {
          formData.append('file', this.file)
          if (this.azienda && this.azienda.id) {
            formData.append('id_azienda', this.azienda.id);
          } else {
            formData.append('id_contatto', this.contatto.id);
          }
          formData.append('descrizione', this.descrizione.charAt(0).toUpperCase() + this.descrizione.slice(1));
          formData.append('categoria', this.categoria);
          if (this.data_scadenza) {
            formData.append('data_scadenza', this.data_scadenza.toISOString())
          }
          axios.post( process.env.VUE_APP_BACKEND_API + url,
            formData,
            {
              headers: { "Access-Control-Allow-Origin": "*", 'Content-Type': 'application/json',},
              withCredentials: true,
              onUploadProgress: ( progressEvent ) => {
                this.uploadPercentage = parseInt( Math.round( ( progressEvent.loaded * 100 ) / progressEvent.total ) );
              }
            }
          ).then((r) => {
            this.$emit('documento-creato', 'OK')
          })
          .catch((e) => {
            console.log('FAILURE!!', e);
          });
        } else {
          let obj = {
            id: this.id,
            id_azienda: this.azienda.id,
            descrizione: this.descrizione,
            categoria: this.categoria
          }
          if (this.data_scadenza) {
            obj['data_scadenza'] = this.data_scadenza
          }
          axios.post( process.env.VUE_APP_BACKEND_API+'/azienda/documento/modifica',
            obj,
            {
              headers: { "Access-Control-Allow-Origin": "*", 'Content-Type': 'application/json',},
              withCredentials: true,
            }
          ).then((r) => {
            this.$emit('documento-creato', 'OK')
          })
          .catch((e) => {
            console.log('FAILURE!!', e);
          });
        }
      })
    },
    validateDocumento() {
      return new Promise((resolve, reject) => {
        this.$validator.validateAll('documento').then(result => {
          if (result) {
            if(this.id) {
              this.file.name = this.nome
            }
            if(this.file.name) {
              resolve(true)
            }
            else {
              document.getElementById('fileError').innerHTML = "Selezionare un file"
              reject("select a file");
            }
          } else {
            reject("correct all values");
          }
        })
      })
    },
    eliminaDocumento(ev) {
      this.$emit('elimina',this.selected.id,ev)
    },
    formatDate(date) {
      var options = { weekday: "long", year: "numeric", month: "short", day: "numeric" }
      return date.toLocaleDateString("it-IT", options).split(' ').map( (e) => e.charAt(0).toUpperCase() + e.substring(1)).join(' ')
    },
    closeSidebar(ev) {
      this.$emit('close-me')
      ev.stopPropagation()
    },
  },

  mounted() {
    this.canEdit = this.$acl.check('responsabile')

    if (this.selected && this.selected.azienda) {
      Object.keys(this.selected).forEach(e => this[e] = !this.selected[e] ? "" : this.selected[e])
      if (this.azienda) {
        this.azienda['label'] = [this.azienda.ragione_sociale,this.azienda.codice_fiscale].join(' ')
      } else {
        this.contatto['label'] = [this.contatto.cognome,this.contatto.nome].join(' ')
        this.radio_ca = 'contatto'
      }

    }
  },
  components: {
    Datepicker,
    'v-select': vSelect,
    DragDropFile,
  },
  watch: {
    radio_ca (val) {
      this.selectorKey = Math.random()
      if (val == 'azienda') this.contatto = null
      else this.azienda = null
    },
  }
}
</script>
